import { useApolloClient } from "@apollo/client";
import { HeaderBackButtonProps } from "@react-navigation/elements";
import { createStackNavigator } from "@react-navigation/stack";
import {
    StyleFunction,
    useAuth,
    useMe,
    useRoutePropsFromRouteConfig,
    useThemedStyle,
} from "@venuepos/react-common";
import React, { useCallback, useMemo } from "react";

import { RootStackParamList } from ".";
import { routeConfig } from "../screens/navigator-routes";
import { LeftHeader } from "./left-header";
import { RightHeader } from "./right-header";
import { ImageStyle, TextStyle, ViewStyle } from "react-native";
import { ENV_HOSTNAME } from "..";

const Stack = createStackNavigator<RootStackParamList>();

export function StackScreen() {
    const me = useMe();
    const auth = useAuth();
    const client = useApolloClient();
    const screens = useRoutePropsFromRouteConfig(routeConfig);
    const styles = useThemedStyle(styleFunc);

    const headerLeft = useCallback(
        (props: HeaderBackButtonProps) => <LeftHeader buttonProps={props} />,
        []
    );

    const headerRight = useCallback(
        () => <RightHeader loggedInUser={me} client={client} auth={auth} />,
        [auth, client, me]
    );

    // Color the topbar differently on development and test
    let headerStyle: ImageStyle & TextStyle & ViewStyle;
    switch (ENV_HOSTNAME) {
        case "localhost":
            headerStyle = styles.developmentHeader;
            break;
        case "test.env.venuepos.net":
            headerStyle = styles.testHeader;
            break;
        default:
            headerStyle = styles.header;
    }

    const screenOpts = useMemo(
        () => ({
            headerLeft,
            headerRight,
            headerStyle,
        }),
        [headerLeft, headerRight, headerStyle]
    );

    return (
        <Stack.Navigator screenOptions={screenOpts}>
            {screens.map(screen => (
                <Stack.Screen key={screen.name} {...screen} />
            ))}
        </Stack.Navigator>
    );
}

const styleFunc: StyleFunction = theme => ({
    header: { backgroundColor: theme.colors.background },
    developmentHeader: {
        backgroundColor: theme.colors.warning,
    },
    testHeader: { backgroundColor: theme.colors.success },
});
